import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { checklist } from '../data/offer';
export function ChecklistSection() {
  return <section className="bg-stage-deep bg-grid py-16" aria-labelledby="includes-title" data-id="element-50" data-mp="2ly2a5adbhs57">
      <div className="mx-auto max-w-5xl px-4" data-id="element-51" data-mp="2m0eozens3me1">
        <h2 id="includes-title" className="text-center text-3xl font-extrabold uppercase text-white" data-id="element-52" data-mp="2qw3tzxikhvhq">Todos los tomos incluyen</h2>
        <div className="mt-9 grid gap-x-10 gap-y-4 md:grid-cols-2" data-id="element-53" data-mp="2c6xyajixunel">
          {checklist.map(([title, detail], index) => <motion.div key={title} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: index * 0.02,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 p-2" data-id="element-54" data-mp="237klphzipipn" data-mpi={index}>
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-sm bg-gold" data-id="element-55" data-mp="1y8r71m8hvlnw">
                <CheckIcon className="h-3.5 w-3.5 text-petrolDark" strokeWidth={3} data-id="element-56" data-mp="1irll7jgmooe2" />
              </span>
              <p data-id="element-57" data-mp="1dss31dqec97k">
                <b className="block text-sm font-bold text-white" data-id="element-58" data-mp="1dta9t4aoq5tq">{title}</b>
                <span className="text-sm text-mutedDark" data-id="element-59" data-mp="1rs1kshu93bdn">{detail}</span>
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}